import { render, staticRenderFns } from "./CvsSubmitted.vue?vue&type=template&id=54d2d9c4"
import script from "./CvsSubmitted.vue?vue&type=script&lang=js"
export * from "./CvsSubmitted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports